import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";
import { CircularProgress, Box, Typography } from "@mui/material";

const SSOCallback = () => {
    const [searchParams] = useSearchParams();
    const { provider } = useParams();
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const [error, setError] = useState(null);

    useEffect(() => {
        const code = searchParams.get("code");
        if (code) {
            handleCallback(code);
        } else {
            setError("No authorization code received.");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCallback = async (code) => {
        try {
            const redirect_uri = window.location.origin + `/sso/callback/${provider}`;
            const response = await axios.post(`/api/auth/v1/sso/callback/${provider}`, {
                code,
                redirect_uri
            });

            const { access_token, refresh_token, user_name, role } = response.data;
            
            setAuth({ user_name, role, access_token, refresh_token });
            
            window.localStorage.setItem("access_token", access_token);
            window.localStorage.setItem("refresh_token", refresh_token);
            window.localStorage.setItem("user_name", user_name);
            window.localStorage.setItem("roles", role);

            if (role === "admin" || role === "superadmin" || role === "member") {
                navigate("/home", { replace: true });
            } else {
                navigate("/", { replace: true });
            }
        } catch (err) {
            console.error("SSO Callback Error:", err);
            setError(err?.response?.data?.message || "Authentication failed.");
            setTimeout(() => navigate("/"), 3000);
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh" gap={2}>
            {!error ? (
                <>
                    <CircularProgress />
                    <Typography>Completing sign in...</Typography>
                </>
            ) : (
                <Typography color="error">{error} Redirecting to login...</Typography>
            )}
        </Box>
    );
};

export default SSOCallback;
